import ComponentElement from 'components/component-element';
import CancellationPolicy from '/modules/hotels/src/js/components/order/cancellation-policy/data/cancellation-policy';

const View = (CE = ComponentElement) => {
    return class extends CE {
        constructor($element, options) {
            super($element, options);

            this.cancellationPolicy = new CancellationPolicy(this.options);
        }

        revise(data) {
            this.cancellationPolicy.set(data);
        }
    }
};

export default View;